var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, formTracking, isPhone, ctaButtonName, ab_flipped_cities_lead_form, ctaText, leadFormTitle, ab_hide_lead_msg_text, ab_tcpa_combined, isDesktop, ab_redesign_lf_2_class } = options; 
__p+='\n';
 let formName = formTracking.name || "request_more_details"; 
__p+='\n';
 let isBottomPosition = formTracking.positionLong === 'bottom' 
__p+='\n';
 let isFlippedVariation = ab_flipped_cities_lead_form == "V1" && property.lead_attributes && property.lead_attributes.flip_the_market_enabled && property.lead_attributes.lead_type == "co_broke" 
__p+='\n';
 let isNotLCMMarket = ab_tcpa_combined === "V1" && property.lead_attributes && (property.lead_attributes.lead_type === "co_broke" || property.lead_attributes.lead_type === "advantage_pro") 
__p+='\n';
 if(ctaText == 'V1' && ctaButtonName == "Contact Agent") { 
__p+='\n  ';
 ctaButtonName = "Contact an Agent" 
__p+='\n';
 } 
__p+='\n\n';
 let isNewPlan = false; 
__p+='\n';
 if (property && property.property_type === 'new_plan') { 
__p+='\n  ';
 isNewPlan = true; 
__p+='\n';
 } 
__p+='\n';
 let nameFieldPlaceholder;
  if (MOVE_DATA.ab_lead_name) { // LDP-193
    nameFieldPlaceholder = "Name";
  } else {
    nameFieldPlaceholder = "Your Name";
  }

__p+='\n\n';
 let isFlippedMarket = false;
  if (property && property.lead_attributes && property.lead_attributes.flip_the_market_enabled) {
    isFlippedMarket = true;
  }

__p+='\n\n';
 let leadFormTextMessage = property.address ? property.address : 'this property' 
__p+='\n';
 if (isNewPlan) { 
__p+='\n  ';
 const propertyText = property.name && property.name.toLowerCase().includes('plan') ? `${property.name}` : `${property.name} plan` 
__p+='\n  ';
 leadFormTextMessage = property.name ? `${propertyText} in the ${property.new_community_name} community` : 'this plan' 
__p+='\n';
 }
__p+='\n\n';
 let redesignWrapper;
  if (!isFlippedMarket) {
    if (ab_redesign_lf_2_class === 'ab-lf-redesign-2-v1' || ab_redesign_lf_2_class === 'ab-lf-redesign-2-v2') {
      redesignWrapper = ab_redesign_lf_2_class;
    } else {
      redesignWrapper = '';
    }
  }

__p+='\n\n';
 property.lead_form_title = leadFormTitle 
__p+='\n';
 if (!property.suppress_lead_form) { 
__p+='\n  ';
 if (property.display_request_more_details_form) { 
__p+='\n    ';
 if (ab_redesign_lf_2_class === 'ab-lf-redesign-2-v2' && isPhone && !isFlippedMarket) { 
__p+='\n    <div class="ab-lf-redesign-2-v2">\n      <div class="lf-redesign-v2-container">\n        <div class="open-house-img lf-redesign-image ';
 if (!property.photos) { 
__p+='hide';
 } 
__p+='">\n          <img src="';
 if (property.photos) { 
__p+=''+
((__t=(property.photos[0].url))==null?'':__t)+
'';
 } 
__p+='">\n        </div>\n        <div id="primary_request_more_details" class="leadForm lead-form-primary qv-lead-form '+
((__t=( property.lead_form_message || isBottomPosition ? '' : 'form-sm' ))==null?'':__t)+
' '+
((__t=( isBottomPosition ? 'form-lg': '' ))==null?'':__t)+
'">\n          ';
 if (isFlippedVariation) { 
__p+='\n            <div class="text-center">\n              <h1 class="lead_form_title">Get More Info</h1>\n              <p class="lead_form_call_title"><span ><div class="lead-800-phone-img"></div></span><span class="lead-800-call-text"><a href="tel:855.447.3683" data-phone-number="855.447.3683" data-phone-click-tracking="'+
((__t=( property.property_status ))==null?'':__t)+
':ldp_exposed_form:phone_lead">Call 855.447.3683</a></span></p>\n              <p class="lead_form_call_title">Call or send your request below.<br/>Get a response in under a minute.</p>\n            </div>\n          ';
} else { 
__p+='\n            ';
 if (property.display_tfn_on_lead_form && property.toll_free_number) { 
__p+='\n              <h3 class="qv-lead-form-toll-free margin-bottom-sm link-tertiary text-center">\n                <i class="ra ra-phone"></i>\n                ';
 if (/Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent)) { 
__p+='\n                  <a href="tel:'+
((__t=( property.toll_free_number ))==null?'':__t)+
'" class="phone-tracking" data-business-card="office" data-phone-number="'+
((__t=( property.toll_free_number ))==null?'':__t)+
'" data-phone-number-type="tfn">'+
((__t=( property.toll_free_number ))==null?'':__t)+
'</a>\n                ';
 } else { 
__p+='\n                  <span class="font-semibold">'+
((__t=( property.toll_free_number ))==null?'':__t)+
'</span>\n                ';
 } 
__p+='\n              </h3>\n            ';
 } 
__p+='\n            <div class="clearfix">\n              <div class="lead-form-title-wrapper">\n                ';
 if (property.lead_form_message) { 
__p+='\n                  <h3 class="lead-form-title font-semibold text-left margin-top-lg margin-bottom-lg">\n                    Get in touch with an agent\n                  </h3>\n                ';
 } if (isBottomPosition && !isPhone && !MOVE_DATA.flg_lead_form_header_enabled) { 
__p+='\n                  <h3 class="lead-form-title font-semibold text-center no-margin">\n                    Ask a question\n                  </h3>\n                ';
 } else { 
__p+='\n                  <h3 class="lead-form-title font-semibold text-center no-margin">\n                    '+
((__t=( property.lead_form_title ))==null?'':__t)+
'\n                  </h3>\n                ';
 } 
__p+='\n              </div>\n            </div>\n          ';
 } 
__p+='\n          <form id="'+
((__t=( formTracking.id ))==null?'':__t)+
'" name="'+
((__t=( formName ))==null?'':__t)+
'" class="new_leads_form_data" action="/leads" accept-charset="UTF-8" method="post" novalidate="novalidate">\n            <input name="utf8" type="hidden" value="&#x2713;" />\n            <input type="hidden" name="authenticity_token" value="'+
((__t=( $('meta[name="csrf-token"]').attr('content') ))==null?'':__t)+
'" />\n            <input value="'+
((__t=( property.lead_service ))==null?'':__t)+
'" type="hidden" name="leads_form_data[lead_service]" id="leads_form_data_lead_service" />\n            <input value="'+
((__t=( property.lead_capture_product ))==null?'':__t)+
'" type="hidden" name="leads_form_data[lead_capture_product]" id="leads_form_data_lead_capture_product" />\n            <input type="hidden" name="full_address_display" id="full_address_display" value="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" />\n            <input type="hidden" name="points" id="points" value="'+
((__t=( property.long + ',' + property.lat ))==null?'':__t)+
'" />\n            <input type="hidden" name="prop_status" id="prop_status" value="'+
((__t=( property.status ))==null?'':__t)+
'" />\n            <input type="hidden" name="prop_type" id="prop_type" value="'+
((__t=( property.type || property.prop_type ))==null?'':__t)+
'" />\n            <input type="hidden" name="city" id="city" value="'+
((__t=( property.city ))==null?'':__t)+
'" />\n            <input type="hidden" name="state" id="state" value="'+
((__t=( property.state ))==null?'':__t)+
'" />\n            <input type="hidden" name="price" id="price" value="'+
((__t=( property.price ))==null?'':__t)+
'" />\n            <input type="hidden" name="leads_form_data[community_id]" id="leads_form_data_community_id" value="'+
((__t=( property.community_id || (property.new_community && property.new_community.id) ))==null?'':__t)+
'" />\n            <input type="hidden" name="display_tcpa_message" id="display_tcpa_message" value="'+
((__t=( property.display_tcpa_message ))==null?'':__t)+
'" />\n            <input type="hidden" name="universal_leadid" id="leadid_token" />\n            <div class="form-group form-group-addon-short form-group-min form-group-min-name">\n            ';
 if ( property.flags && property.flags.is_spec_home && property.source ) { 
__p+='\n              <input type="hidden" name="leads_form_data[spec_id]" id="leads_form_data_spec_id" value="'+
((__t=( property.source && property.source.id ))==null?'':__t)+
'" />\n              <input type="hidden" name="leads_form_data[plan_id]" id="leads_form_data_plan_id" value="'+
((__t=( property.source && property.source.plan_id ))==null?'':__t)+
'" />\n             ';
 } 
__p+='  \n              ';
 if (isFlippedVariation) { 
__p+='\n                <span class="form-icon name_icon"></span>\n              ';
} else { 
__p+='\n                <i class="form-icon ra ra-identity"></i>\n              ';
 } 
__p+='\n              <input class="form-control fullName" placeholder="'+
((__t=( nameFieldPlaceholder ))==null?'':__t)+
'" title="Your Name" id="primary_lead_name" type="text" name="leads_form_data[name]" autocomplete="name" />\n            </div>\n            <div class="form-group form-group-addon-short form-group-min">\n              ';
 if (isFlippedVariation) { 
__p+='\n                <span class="form-icon email_icon"></span>\n              ';
} else {
__p+='\n                <i class="form-icon ra ra-envelope-1"></i>\n              ';
 } 
__p+='\n              <input class="form-control email" placeholder=';
if (isFlippedVariation) { 
__p+='"Your Email" ';
 } else { 
__p+=' "Email" ';
 } 
__p+=' title="Email" id="primary_lead_email" type="email" name="leads_form_data[email]" autocomplete="email" />\n            </div>\n            <div class="form-group form-group-addon-short form-group-min ';
 if (ab_hide_lead_msg_text === 'V1') { 
__p+='\'qv-bt-lead-form\'';
 } 
__p+='">\n              ';
 if (isFlippedVariation) { 
__p+='\n                <span class="form-icon phone_icon"></span>\n              ';
} else {
__p+='\n                <i class="form-icon ra ra-phone"></i>\n              ';
 } 
__p+='\n              <input class="form-control phone" placeholder=';
if (isFlippedVariation) { 
__p+='"Your Phone" ';
 } else { 
__p+=' "Phone" ';
 } 
__p+=' title="Phone" id="primary_lead_phone" type="tel" name="leads_form_data[phone]" autocomplete="tel-national" />\n            </div>\n            ';
 if (ab_hide_lead_msg_text === 'V1') { 
__p+='\n              <div class="form-group form-group-min ldp-text-ld-form-hide">\n                <a class="click-text-msg" data-omtag="for_sale:ldp-quickview:lead_form:edit_message">Add message</a>\n              </div>\n            ';
 } 
__p+='\n            <div class="form-group form-group-min ';
 if (ab_hide_lead_msg_text==='V1') { 
__p+='hide open-text-msg-ab';
 } 
__p+='">\n              <label class="message-label no-show" for="primary_lead_message">Message</label>\n              <span class="input-group-addon hide">\n                <i class="ra ra-bubble"></i>\n              </span>\n              ';
 if (property.lead_form_message) { 
__p+='\n                <textarea class="form-control message" rows="4" col="10" placeholder="'+
((__t=( property.lead_form_message ))==null?'':__t)+
'" id="primary_lead_message" origin_val="'+
((__t=( property.lead_form_message ))==null?'':__t)+
'" name="leads_form_data[message]">'+
((__t=( property.lead_form_message ))==null?'':__t)+
'</textarea>\n              ';
 } else { 
__p+='\n              <textarea class="form-control message" rows="2" col="10" id="primary_lead_message" origin_val="I&#39;m interested in '+
((__t=( property.address ))==null?'':__t)+
'." aria-label="primary-lead-message" name="leads_form_data[message]">I&#39;m interested in '+
((__t=( leadFormTextMessage ))==null?'':__t)+
'.</textarea>\n              ';
 } 
__p+='\n            </div>\n            ';
 if (property.display_rcm_checkbox && !isFlippedVariation ) { 
__p+='\n              <div class="form-group no-margin">\n              ';
 var isChecked = MOVE_DATA.is_lcm_enabled == true ? 'checked' : '' 
__p+='\n                <div class="checkbox no-padding-bottom ';
 if (property.flags && property.flags.is_spec_home) { 
__p+='hide';
 } 
__p+='">\n                  <label>\n                    <input name="leads_form_data[is_pre_approved]" type="hidden" value="0" />\n                    <input class="preApproved" id="primary_lead_preApproved" type="checkbox" '+
((__t=( isChecked ))==null?'':__t)+
' value="1" name="leads_form_data[is_pre_approved]" /> Get pre-approved by a lender.\n                  </label>\n                </div>\n                <div class="checkbox no-show js-lead-lender-items js-mrc-item ';
 if ((property.price && parseInt(property.price) < 100000) || (property.flags && property.flags.is_spec_home)) { 
__p+='hide';
 } 
__p+='">\n                  <label>\n                    <input name="leads_form_data[is_military]" type="hidden" value="0" />\n                    <input class="js-veterans-checkbox" id="primary_lead_isMilitary" type="checkbox" value="1" name="leads_form_data[is_military]" /> Did you or your spouse serve in the US military?\n                  </label>\n                </div>\n              </div>\n              ';
 if (!MOVE_DATA.is_lcm_enabled) { 
__p+='\n                  <div class="form-group form-inline no-show creditScore js-mrc-item js-lead-lender-items">\n                    <label for="creditscore" class="font-normal margin-right">Credit Score</label>\n                    <select class="credit-selectbox selectpicker select-full-width" id="primary_lead_credit_score" name="leads_form_data[credit_score]">\n                      <option value="excellent">Excellent (720+)</option>\n                      <option selected="selected" value="good">Good (680 to 719)</option>\n                      <option value="fair">Fair (620 to 679)</option>\n                      <option value="poor">Poor (619 and below)</option>\n                    </select>\n                  </div>\n              ';
 } 
__p+='\n            ';
 } 
__p+='\n            <div class="clearfix">\n                ';
 if (!isNewPlan) { 
__p+='\n                <button type="submit" name="commit" class="submit btn btn-block btn-primary less-padding round-cta ab-email-text" id="primary_lead_submit" data-omtrack="homes:'+
((__t=( formTracking.snapshot ? 'snapshot' : 'rmd' ))==null?'':__t)+
':'+
((__t=( formTracking.positionLong ))==null?'':__t)+
'" data-position="'+
((__t=( formTracking.positionMid ))==null?'':__t)+
'">\n                  <div class="icon-email-container"><span class="email-icon"></span><span class="ab-email-text-form">\n                    '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n                  </span></div>\n                </button>\n                ';
 } else { 
__p+='\n                  <input type="submit" name="commit" value="'+
((__t=( ctaButtonName ))==null?'':__t)+
'" class="submit btn btn-block btn-primary lead-form-submit less-padding round-cta" id="primary_lead_submit" data-omtrack="homes:'+
((__t=( formTracking.snapshot ? 'snapshot' : 'rmd' ))==null?'':__t)+
':'+
((__t=( formTracking.positionLong ))==null?'':__t)+
'" data-position="'+
((__t=( formTracking.positionMid ))==null?'':__t)+
'" data-disable-with="Contact Agent" />\n                ';
 } 
__p+='\n                ';
 if (!property.display_tcpa_message) { 
__p+='\n                  <div class="padding-top-sm link-tertiary font-size-xsmall text-justify">\n                    ';

                      // Jornaya LeadiD input and label wrapper for identifying TCPA disclosure
                      // see "TCPA Disclosure Labels"
                      // https://support.jornaya.com/s/article/How-do-I-add-Jornaya-TCPA-labels-tags-to-my-site
                    
__p+='\n                    ';
 var suffix = (formTracking.positionLong || '').replace(/[-:]/g, '_') 
__p+='\n                    <input type="hidden" id="leadid_tcpa_disclosure_'+
((__t=( suffix ))==null?'':__t)+
'"/>\n                    <label class="font-normal no-margin" for="leadid_tcpa_disclosure_'+
((__t=( suffix ))==null?'':__t)+
'">\n                      By proceeding, you consent to receive calls and texts at the number you provided, including marketing by autodialer\n                      and prerecorded and artificial voice, and email, from realtor.com and<span class="tooltip-fixed">\n                      <a tabindex="0" href="javascript:void(0)" data-toggle="popover" data-placement="top" data-html="true"\n                      data-content="'+
((__t=(JST["quick_view/templates/tcpa_others_disclaimer"]()))==null?'':__t)+
'"><u>others</u></a></span> about your\n                      inquiry and other home-related matters, but not as a condition of any purchase.<a class="cursor-pointer\n                      show-more-privacy-policy">&nbsp;More...</a>\n                      <span class="more-privacy-policy"></span>\n                    </label>\n                  </div>\n                ';
 } 
__p+='\n              <div class="no-show js-mrc-item js-mrc-text rcm-text padding-top-sm link-tertiary font-size-xsmall">\n                ';

                  // Jornaya LeadiD input and label wrapper for identifying TCPA disclosure
                  // see "TCPA Disclosure Labels"
                  // https://support.jornaya.com/s/article/How-do-I-add-Jornaya-TCPA-labels-tags-to-my-site
                
__p+='\n                ';
 var suffix = (formTracking.positionLong || '').replace(/[-:]/g, '_') 
__p+='\n                <input type="hidden" id="leadid_tcpa_disclosure_'+
((__t=( suffix ))==null?'':__t)+
'"/>\n                <label class="font-normal no-margin" for="leadid_tcpa_disclosure_'+
((__t=( suffix ))==null?'':__t)+
'">\n                  <a tabindex="0" data-toggle="popover" data-placement="top" data-trigger="focus" data-html="true" data-content="'+
((__t=(JST["quick_view/templates/mrc_modal_disclaimer"]()))==null?'':__t)+
'"><b>Powered by</b></a>\n                  Mortgage Research Center, LLC (<a href="http://www.nmlsconsumeraccess.org" rel="nofollow" target="_blank">NMLS #1907</a>).\n                  <br><b>CONSENT.</b>  By proceeding, I consent to my information being shared with, and being contacted by, up to four\n                  loan professionals from this <a href="https://www.mortgageresearchcenter.org/partners/" rel="nofollow" target="_blank"><b>network of advertisers</b></a>\n                  as to my inquiry and about related services and offers from them, including via an automatic telephone dialing system and an artificial or prerecorded\n                  voice, at the phone number I have provided, and including by text, email and other means.  This consent is not a condition of any purchase of\n                  any kind from anyone and applies even if I am on a corporate, state or national Do Not Call list. I agree my information is subject to the\n                  <a href="https://marketing.move.com/privacy-policy/"rel="nofollow" target="_blank">realtor.com<sup>&reg;</sup> <b>Privacy Policy</b></a>.\n                  I acknowledge Mortgage Research Center, LLC (“MRC”) will receive my information and route it as necessary to the above-referenced loan professionals (up to four).\n                  Please <a tabindex="0" data-toggle="popover" data-placement="top" data-trigger="focus" data-html="true" data-content="'+
((__t=(JST["quick_view/templates/mrc_modal_disclaimer"]()))==null?'':__t)+
'"><b>READ HERE</b></a>\n                  for certain disclosures about your inquiry.\n                </label>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    ';
 } else { 
__p+='\n      <div class="'+
((__t=( redesignWrapper ))==null?'':__t)+
'">\n        <div id="primary_request_more_details" class="leadForm lead-form-primary qv-lead-form '+
((__t=( property.lead_form_message || isBottomPosition ? '' : 'form-sm' ))==null?'':__t)+
' '+
((__t=( isBottomPosition ? 'form-lg': '' ))==null?'':__t)+
'">\n          ';
 if (isFlippedVariation) { 
__p+='\n            <div class="text-center">\n              <h1 class="lead_form_title">Get More Info</h1>\n              <p class="lead_form_call_title"><span ><div class="lead-800-phone-img"></div></span><span class="lead-800-call-text"><a href="tel:855.447.3683" data-phone-number="855.447.3683" data-phone-click-tracking="'+
((__t=( property.property_status ))==null?'':__t)+
':ldp_exposed_form:phone_lead">Call 855.447.3683</a></span></p>\n              <p class="lead_form_call_title">Call or send your request below.<br/>Get a response in under a minute.</p>\n            </div>\n          ';
} else { 
__p+='\n            ';
 if (property.display_tfn_on_lead_form && property.toll_free_number) { 
__p+='\n              <h3 class="qv-lead-form-toll-free margin-bottom-sm link-tertiary text-center">\n                <i class="ra ra-phone"></i>\n                ';
 if (/Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent)) { 
__p+='\n                  <a href="tel:'+
((__t=( property.toll_free_number ))==null?'':__t)+
'" class="phone-tracking" data-business-card="office" data-phone-number="'+
((__t=( property.toll_free_number ))==null?'':__t)+
'" data-phone-number-type="tfn">'+
((__t=( property.toll_free_number ))==null?'':__t)+
'</a>\n                ';
 } else { 
__p+='\n                  <span class="font-semibold">'+
((__t=( property.toll_free_number ))==null?'':__t)+
'</span>\n                ';
 } 
__p+='\n              </h3>\n            ';
 } 
__p+='\n            <div class="clearfix">\n              <div class="lead-form-title-wrapper">\n                ';
 if (property.lead_form_message) { 
__p+='\n                  <h3 class="lead-form-title font-semibold text-left margin-top-lg margin-bottom-lg">\n                    Get in touch with an agent\n                  </h3>\n                ';
 } if (isBottomPosition && !isPhone && !MOVE_DATA.flg_lead_form_header_enabled) { 
__p+='\n                  <h3 class="lead-form-title font-semibold text-center no-margin">\n                    Ask a question\n                  </h3>\n               ';
 } else { 
__p+='\n                  <h3 class="lead-form-title font-semibold text-center no-margin">\n                    '+
((__t=( property.lead_form_title ))==null?'':__t)+
'\n                  </h3>\n                ';
 } 
__p+='\n              </div>\n            </div>\n          ';
 } 
__p+='\n          <form id="'+
((__t=( formTracking.id ))==null?'':__t)+
'" name="'+
((__t=( formName ))==null?'':__t)+
'" class="new_leads_form_data" action="/leads" accept-charset="UTF-8" method="post" novalidate="novalidate">\n            <input name="utf8" type="hidden" value="&#x2713;" />\n            <input type="hidden" name="authenticity_token" value="'+
((__t=( $('meta[name="csrf-token"]').attr('content') ))==null?'':__t)+
'" />\n            <input value="'+
((__t=( property.lead_service ))==null?'':__t)+
'" type="hidden" name="leads_form_data[lead_service]" id="leads_form_data_lead_service" />\n            <input value="'+
((__t=( property.lead_capture_product ))==null?'':__t)+
'" type="hidden" name="leads_form_data[lead_capture_product]" id="leads_form_data_lead_capture_product" />\n            <input type="hidden" name="full_address_display" id="full_address_display" value="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" />\n            <input type="hidden" name="points" id="points" value="'+
((__t=( property.long + ',' + property.lat ))==null?'':__t)+
'" />\n            <input type="hidden" name="prop_status" id="prop_status" value="'+
((__t=( property.status ))==null?'':__t)+
'" />\n            <input type="hidden" name="prop_type" id="prop_type" value="'+
((__t=( property.type || property.prop_type ))==null?'':__t)+
'" />\n            <input type="hidden" name="city" id="city" value="'+
((__t=( property.city ))==null?'':__t)+
'" />\n            <input type="hidden" name="state" id="state" value="'+
((__t=( property.state ))==null?'':__t)+
'" />\n            <input type="hidden" name="price" id="price" value="'+
((__t=( property.price ))==null?'':__t)+
'" />\n            <input type="hidden" name="leads_form_data[community_id]" id="leads_form_data_community_id" value="'+
((__t=( property.community_id || (property.new_community && property.new_community.id) ))==null?'':__t)+
'" />\n            ';
 if ( property.flags && property.flags.is_spec_home && property.source ) { 
__p+='\n              <input type="hidden" name="leads_form_data[spec_id]" id="leads_form_data_spec_id" value="'+
((__t=( property.source && property.source.id ))==null?'':__t)+
'" />\n              <input type="hidden" name="leads_form_data[plan_id]" id="leads_form_data_plan_id" value="'+
((__t=( property.source && property.source.plan_id ))==null?'':__t)+
'" />\n            ';
 } 
__p+='  \n            <input type="hidden" name="display_tcpa_message" id="display_tcpa_message" value="'+
((__t=( property.display_tcpa_message ))==null?'':__t)+
'" />\n            <input type="hidden" name="universal_leadid" id="leadid_token" />\n            <div class="form-group form-group-addon-short form-group-min form-group-min-name">\n              ';
 if (isFlippedVariation) { 
__p+='\n                <span class="form-icon name_icon"></span>\n              ';
} else { 
__p+='\n                <i class="form-icon ra ra-identity"></i>\n              ';
 } 
__p+='\n              <input class="form-control fullName" placeholder="'+
((__t=( nameFieldPlaceholder ))==null?'':__t)+
'" title="Your Name" id="primary_lead_name" type="text" name="leads_form_data[name]" autocomplete="name" />\n            </div>\n            <div class="form-group form-group-addon-short form-group-min">\n              ';
 if (isFlippedVariation) { 
__p+='\n                <span class="form-icon email_icon"></span>\n              ';
} else {
__p+='\n                <i class="form-icon ra ra-envelope-1"></i>\n              ';
 } 
__p+='\n              <input class="form-control email" placeholder=';
if (isFlippedVariation) { 
__p+='"Your Email" ';
 } else { 
__p+=' "Email" ';
 } 
__p+=' title="Email" id="primary_lead_email" type="email" name="leads_form_data[email]" autocomplete="email" />\n            </div>\n            <div class="form-group form-group-addon-short form-group-min ';
 if (ab_hide_lead_msg_text === 'V1') { 
__p+='\'qv-bt-lead-form\'';
 } 
__p+='">\n              ';
 if (isFlippedVariation) { 
__p+='\n                <span class="form-icon phone_icon"></span>\n              ';
} else {
__p+='\n                <i class="form-icon ra ra-phone"></i>\n              ';
 } 
__p+='\n              <input class="form-control phone" placeholder=';
if (isFlippedVariation) { 
__p+='"Your Phone" ';
 } else { 
__p+=' "Phone" ';
 } 
__p+=' title="Phone" id="primary_lead_phone" type="tel" name="leads_form_data[phone]" autocomplete="tel-national" />\n            </div>\n            ';
 if (ab_hide_lead_msg_text === 'V1') { 
__p+='\n              <div class="form-group form-group-min ldp-text-ld-form-hide">\n                <a class="click-text-msg" data-omtag="for_sale:ldp-quickview:lead_form:edit_message">Add message</a>\n              </div>\n            ';
 } 
__p+='\n            <div class="form-group form-group-min ';
 if (ab_hide_lead_msg_text==='V1') { 
__p+='hide open-text-msg-ab';
 } 
__p+='">\n              <label class="message-label no-show" for="primary_lead_message">Message</label>\n              <span class="input-group-addon hide">\n                <i class="ra ra-bubble"></i>\n              </span>\n              ';
 if (property.lead_form_message) { 
__p+='\n                <textarea class="form-control message" rows="4" col="10" placeholder="'+
((__t=( property.lead_form_message ))==null?'':__t)+
'" id="primary_lead_message" origin_val="'+
((__t=( property.lead_form_message ))==null?'':__t)+
'" name="leads_form_data[message]">'+
((__t=( property.lead_form_message ))==null?'':__t)+
'</textarea>\n              ';
 } else { 
__p+='\n              <textarea class="form-control message" rows="2" col="10" id="primary_lead_message" origin_val="I&#39;m interested in '+
((__t=( property.address ))==null?'':__t)+
'." aria-label="primary-lead-message" name="leads_form_data[message]">I&#39;m interested in '+
((__t=( leadFormTextMessage ))==null?'':__t)+
'.</textarea>\n              ';
 } 
__p+='\n            </div>\n            ';
 if (property.display_rcm_checkbox && !isFlippedVariation ) { 
__p+='\n              <div class="form-group no-margin">\n              ';
 var isChecked = MOVE_DATA.is_lcm_enabled == true ? 'checked' : '' 
__p+='\n                <div class="checkbox no-padding-bottom ';
 if (property.flags && property.flags.is_spec_home) { 
__p+='hide';
 } 
__p+='">\n                  <label>\n                    <input name="leads_form_data[is_pre_approved]" type="hidden" value="0" />\n                    <input class="preApproved" id="primary_lead_preApproved" type="checkbox" '+
((__t=( isChecked ))==null?'':__t)+
' value="1" name="leads_form_data[is_pre_approved]" /> Get pre-approved by a lender.\n                  </label>\n                </div>\n                <div class="checkbox no-show js-lead-lender-items js-mrc-item ';
 if ((property.price && parseInt(property.price) < 100000) || (property.flags && property.flags.is_spec_home)) { 
__p+='hide';
 } 
__p+='">\n                  <label>\n                    <input name="leads_form_data[is_military]" type="hidden" value="0" />\n                    <input class="js-veterans-checkbox" id="primary_lead_isMilitary" type="checkbox" value="1" name="leads_form_data[is_military]" /> Did you or your spouse serve in the US military?\n                  </label>\n                </div>\n              </div>\n              ';
 if (!MOVE_DATA.is_lcm_enabled) { 
__p+='\n                  <div class="form-group form-inline no-show creditScore js-mrc-item js-lead-lender-items">\n                    <label for="creditscore" class="font-normal margin-right">Credit Score</label>\n                    <select class="credit-selectbox selectpicker select-full-width" id="primary_lead_credit_score" name="leads_form_data[credit_score]">\n                      <option value="excellent">Excellent (720+)</option>\n                      <option selected="selected" value="good">Good (680 to 719)</option>\n                      <option value="fair">Fair (620 to 679)</option>\n                      <option value="poor">Poor (619 and below)</option>\n                    </select>\n                  </div>\n              ';
 } 
__p+='\n            ';
 } 
__p+='\n            <div class="clearfix">\n                ';
 if (!isNewPlan) { 
__p+='\n                <button type="submit" name="commit" class="submit btn btn-block btn-primary less-padding round-cta ab-email-text" id="primary_lead_submit" data-omtrack="homes:'+
((__t=( formTracking.snapshot ? 'snapshot' : 'rmd' ))==null?'':__t)+
':'+
((__t=( formTracking.positionLong ))==null?'':__t)+
'" data-position="'+
((__t=( formTracking.positionMid ))==null?'':__t)+
'">\n                  <div class="icon-email-container"><span class="email-icon"></span><span class="ab-email-text-form">\n                    '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n                  </span></div>\n                </button>\n                ';
 } else { 
__p+='\n                  <input type="submit" name="commit" value="'+
((__t=( ctaButtonName ))==null?'':__t)+
'" class="submit btn btn-block btn-primary lead-form-submit less-padding round-cta" id="primary_lead_submit" data-omtrack="homes:'+
((__t=( formTracking.snapshot ? 'snapshot' : 'rmd' ))==null?'':__t)+
':'+
((__t=( formTracking.positionLong ))==null?'':__t)+
'" data-position="'+
((__t=( formTracking.positionMid ))==null?'':__t)+
'" data-disable-with="Contact Agent" />\n                ';
 } 
__p+='\n                ';
 if (!property.display_tcpa_message) { 
__p+='\n                  <div class="padding-top-sm link-tertiary font-size-xsmall text-justify">\n                    ';

                      // Jornaya LeadiD input and label wrapper for identifying TCPA disclosure
                      // see "TCPA Disclosure Labels"
                      // https://support.jornaya.com/s/article/How-do-I-add-Jornaya-TCPA-labels-tags-to-my-site
                    
__p+='\n                    ';
 var suffix = (formTracking.positionLong || '').replace(/[-:]/g, '_') 
__p+='\n                    <input type="hidden" id="leadid_tcpa_disclosure_'+
((__t=( suffix ))==null?'':__t)+
'"/>\n                    <label class="font-normal no-margin" for="leadid_tcpa_disclosure_'+
((__t=( suffix ))==null?'':__t)+
'">\n                      By proceeding, you consent to receive calls and texts at the number you provided, including marketing by autodialer\n                      and prerecorded and artificial voice, and email, from realtor.com and<span class="tooltip-fixed">\n                      <a tabindex="0" href="javascript:void(0)" data-toggle="popover" data-placement="top" data-html="true"\n                      data-content="'+
((__t=(JST["quick_view/templates/tcpa_others_disclaimer"]()))==null?'':__t)+
'"><u>others</u></a></span> about your\n                      inquiry and other home-related matters, but not as a condition of any purchase.<a class="cursor-pointer\n                      show-more-privacy-policy">&nbsp;More...</a>\n                      <span class="more-privacy-policy"></span>\n                    </label>\n                  </div>\n                ';
 } 
__p+='\n              <div class="no-show js-mrc-item js-mrc-text rcm-text padding-top-sm link-tertiary font-size-xsmall">\n                ';

                  // Jornaya LeadiD input and label wrapper for identifying TCPA disclosure
                  // see "TCPA Disclosure Labels"
                  // https://support.jornaya.com/s/article/How-do-I-add-Jornaya-TCPA-labels-tags-to-my-site
                
__p+='\n                ';
 var suffix = (formTracking.positionLong || '').replace(/[-:]/g, '_') 
__p+='\n                <input type="hidden" id="leadid_tcpa_disclosure_'+
((__t=( suffix ))==null?'':__t)+
'"/>\n                <label class="font-normal no-margin" for="leadid_tcpa_disclosure_'+
((__t=( suffix ))==null?'':__t)+
'">\n                  <a tabindex="0" data-toggle="popover" data-placement="top" data-trigger="focus" data-html="true" data-content="'+
((__t=(JST["quick_view/templates/mrc_modal_disclaimer"]()))==null?'':__t)+
'"><b>Powered by</b></a>\n                  Mortgage Research Center, LLC (<a href="http://www.nmlsconsumeraccess.org" rel="nofollow" target="_blank">NMLS #1907</a>).\n                  <br><b>CONSENT.</b>  By proceeding, I consent to my information being shared with, and being contacted by, up to four\n                  loan professionals from this <a href="https://www.mortgageresearchcenter.org/partners/" rel="nofollow" target="_blank"><b>network of advertisers</b></a>\n                  as to my inquiry and about related services and offers from them, including via an automatic telephone dialing system and an artificial or prerecorded\n                  voice, at the phone number I have provided, and including by text, email and other means.  This consent is not a condition of any purchase of\n                  any kind from anyone and applies even if I am on a corporate, state or national Do Not Call list. I agree my information is subject to the\n                  <a href="https://marketing.move.com/privacy-policy/"rel="nofollow" target="_blank">realtor.com<sup>&reg;</sup> <b>Privacy Policy</b></a>.\n                  I acknowledge Mortgage Research Center, LLC (“MRC”) will receive my information and route it as necessary to the above-referenced loan professionals (up to four).\n                  Please <a tabindex="0" data-toggle="popover" data-placement="top" data-trigger="focus" data-html="true" data-content="'+
((__t=(JST["quick_view/templates/mrc_modal_disclaimer"]()))==null?'':__t)+
'"><b>READ HERE</b></a>\n                  for certain disclosures about your inquiry.\n                </label>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    ';
 } 
__p+='\n  ';
 } 
__p+='\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/forms/qv-sec-lead-form.jst.ejs